export const TELEHEALTH_NO = 'no';
export const TELEHEALTH_HYBRID = 'hybrid';
export const TELEHEALTH_ONLY = 'pure';
